import { AvailableFilters } from '@/types/hdsFilter'
import { API_URLS } from '@/utils/helpers'
import axios from 'axios'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class FilterOptionsMixin extends Vue {
  requiredFilterOptions: AvailableFilters[] = []
  organizationOptions: { value: string | number, text: string }[] = []
  fundingScopeOptions: { value: string | number, text: string }[] = []
  membershipOptions: { value: string | number, text: string }[] = []
  numberOfEmployeesOptions: { value: string | number, text: string }[] = []
  projectFundingCodesOptions: { value: string | number, text: string }[] = []
  organizationLegalFormOptions: { value: string | number, text: string }[] = []
  organizationStatutoryPurposeOptions: { value: string | number, text: string }[] = []
  projectCityOptions: { value: string | number, text: string }[] = []
  projectCountryOptions: { value: string | number, text: string }[] = []
  fundingScopeTargetGroupOptions: { value: string | number, text: string }[] = []
  fundingScopeApproachOptions: { value: string | number, text: string }[] = []
  fundingScopeSocietyGoalsOptions: { value: string | number, text: string }[] = []
  fundingScopeEducationGoalsOptions: { value: string | number, text: string }[] = []
  fundingScopeCrisisReliefOptions: { value: string | number, text: string }[] = []
  fundingScopeElderlyOptions: { value: string | number, text: string }[] = []
  fundingScopeSocialOptions: { value: string | number, text: string }[] = []
  fundingScopeSportOptions: { value: string | number, text: string }[] = []
  fundingScopeAnimalWelfareOptions: { value: string | number, text: string }[] = []
  fundingScopeEnvironmentOptions: { value: string | number, text: string }[] = []
  fundingScopeYouthWelfareOptions: { value: string | number, text: string }[] = []
  fundingScopeSdgOptions: { value: string | number, text: string }[] = []
  fundingScopeScienceOptions: { value: string | number, text: string }[] = []
  fundingScopeArtOptions: { value: string | number, text: string }[] = []
  projectSpecialEventsOptions: { value: string | number, text: string }[] = []

  async fetchFilterOptions (): Promise<void> {
    const promises = []

    for (const opt of this.requiredFilterOptions) {
      promises.push(this.fetchFilterOptionsFor(opt))
    }
    const values = await Promise.all(promises)
    for (const [index, val] of values.entries()) {
      this.setFilterOptionsFor(this.requiredFilterOptions[index], val)
    }
  }

  async fetchFilterOptionsFor(filterOptionKey: AvailableFilters): Promise<{ value: string | number, text: string }[]> {
    const url = API_URLS.FILTER_CONTAINER.FILTER_OPTIONS(filterOptionKey)
    try {
      const response = await axios.get(url)
      return response.data
    } catch {
      this.$emit('show-admin-error')
      return []
    }
  }

  private setFilterOptionsFor(filterOptionKey: AvailableFilters, value): void {
    switch (filterOptionKey) {
      case 'organization':
        this.organizationOptions = value
        break
      case 'funding_scope':
        this.fundingScopeOptions = value
        break
      case 'tags_mitgliedschaft':
        this.membershipOptions = value
        break
      case 'number_of_employees':
        this.numberOfEmployeesOptions = value
        break
      case 'funding_codes':
        this.projectFundingCodesOptions = value
        break
      case 'organization_legal_form':
        this.organizationLegalFormOptions = value
        break
      case 'organization_statutory_purpose':
        this.organizationStatutoryPurposeOptions = value
        break
      case 'project_city':
        this.projectCityOptions = value
        break
      case 'project_country':
        this.projectCountryOptions = value
        break
      case 'funding_scope_target_group':
        this.fundingScopeTargetGroupOptions = value
        break
      case 'funding_scope_approach':
        this.fundingScopeApproachOptions = value
        break
      case 'funding_scope_society_goals':
        this.fundingScopeSocietyGoalsOptions = value
        break
      case 'funding_scope_education_goals':
        this.fundingScopeEducationGoalsOptions = value
        break
      case 'funding_scope_crisis_relief':
        this.fundingScopeCrisisReliefOptions = value
        break
      case 'funding_scope_elderly':
        this.fundingScopeElderlyOptions = value
        break
      case 'funding_scope_social':
        this.fundingScopeSocialOptions = value
        break
      case 'funding_scope_sport':
        this.fundingScopeSportOptions = value
        break
      case 'funding_scope_animal_welfare':
        this.fundingScopeAnimalWelfareOptions = value
        break
      case 'funding_scope_environment':
        this.fundingScopeEnvironmentOptions = value
        break
      case 'funding_scope_youth_welfare':
        this.fundingScopeYouthWelfareOptions = value
        break
      case 'funding_scope_sdg':
        this.fundingScopeSdgOptions = value
        break
      case 'funding_scope_science':
        this.fundingScopeScienceOptions = value
        break
      case 'funding_scope_art':
        this.fundingScopeArtOptions = value
        break
      case 'project_special_events':
        this.projectSpecialEventsOptions = value
        break
    }
  }
}
